import type { HomeTrackingEntity } from "./tracking/home/home";
import home from "./tracking/home/home";
import type { HomePageTrackingEntity } from "./tracking/home/homepage";
import homepage from "./tracking/home/homepage";
import type { HomePageInsightsTrackingEntity } from "./tracking/home/homepageInsights";
import { homePageInsightsTracking } from "./tracking/home/homepageInsights";
import type { HomePageWithDataTrackingEntity } from "./tracking/home/homepageWithData";
import { homePageWithData } from "./tracking/home/homepageWithData";
import type { QueryBarFilterTrackingEntity } from "./tracking/query-bar-filter/queryBarFilter";
import queryBarFilter from "./tracking/query-bar-filter/queryBarFilter";
import type { RankTrackingSchema } from "./tracking/rankTracking/rankTracking";
import rankTracker from "./tracking/rankTracking/rankTracking";
import type { SettingsTrackingEntity } from "./tracking/settings/settings";
import settings from "./tracking/settings/settings";
import type { SetupTrackingEntity } from "./tracking/setup/setup";
import setup from "./tracking/setup/setup";

type ActivationTrackingEntity = {
    home: HomeTrackingEntity;
    homepage: HomePageTrackingEntity;
    homePageInsights: HomePageInsightsTrackingEntity;
    homePageWithData: HomePageWithDataTrackingEntity;
    settings: SettingsTrackingEntity;
    setup: SetupTrackingEntity;
    queryBarFilter: QueryBarFilterTrackingEntity;
    rankTracker: RankTrackingSchema;
};

const createActivationTrackingService = (): ActivationTrackingEntity => {
    return {
        home,
        homepage,
        homePageInsights: homePageInsightsTracking,
        homePageWithData,
        settings,
        setup,
        queryBarFilter,
        rankTracker,
    };
};

export const activationTracking = createActivationTrackingService();
